export default "__VITE_ASSET__B41qm03I__"